import { create } from 'zustand';
import { authAPI } from '@/services/api';

// Store Zustand pour gérer les statistiques du client
const useClientStatsStore = create((set) => ({
  stats: null,
  isLoading: false,
  lastFetch: null,
  
  setStats: (stats) => set({ stats }),
  
  fetchStats: async () => {
    set({ isLoading: true });
    try {
      const response = await authAPI.getClientStatistics();
      const stats = response.data;
      
      set({ 
        stats, 
        isLoading: false,
        lastFetch: Date.now()
      });
      
      return stats;
    } catch (error) {
      console.error('Error fetching client stats:', error);
      set({ isLoading: false });
      return null;
    }
  },
  
  resetStats: () => set({ stats: null }),
}));

// Hook personnalisé pour utiliser le store
export const useClientStats = () => {
  const { 
    stats, 
    isLoading, 
    lastFetch,
    fetchStats,
    setStats,
    resetStats
  } = useClientStatsStore();

  // Rafraîchir automatiquement si les données sont trop anciennes (> 5 minutes)
  const shouldRefresh = !lastFetch || (Date.now() - lastFetch > 5 * 60 * 1000);

  return {
    stats,
    isLoading,
    fetchStats,
    setStats,
    resetStats,
    shouldRefresh,
  };
};

export default useClientStats;
